import { observer } from "mobx-react-lite";
import React from "react";
import { ConfigInputProps } from "../../types/Config";
import { CustomLabelList } from "./priority/CustomLabelList";
import { DowntimeFieldSelect } from "./priority/DowntimeFieldSelect";
import { FrequencyFieldSelect } from "./priority/FrequencyFieldSelect";
import { PriorityFieldSelect } from "./priority/PriorityFieldSelect";
import { RestrictionFieldSelect } from "./priority/RestrictionFieldSelect";

type Props = {} & ConfigInputProps<"priority">;

export const PriorityConfigInput = observer((props: Props) => {
  return (
    <>
      <PriorityFieldSelect />
      <DowntimeFieldSelect />
      <FrequencyFieldSelect />
      <RestrictionFieldSelect />
      <CustomLabelList />
    </>
  );
});
